import { LeadDetailsModel } from '@/typings/models/Lead';
import { LeadActivityModel } from '@/typings/models/LeadActivity';
import { ServiceRequestStyleModel } from '@/typings/models/ServiceRequest';
import dayjs from 'dayjs';
import moment from 'moment';

export function getLeadOpenTasksCount(lead: LeadDetailsModel) {
  if (!lead) return 0
  if (Array.isArray(lead.tasks)){
    return lead.tasks.filter(task => !task.is_completed && !task.retired_at).length
  }
  const openTaskCount = lead.tasks_count - lead.completed_tasks_count
  return !isNaN(openTaskCount) ? openTaskCount : 0
}

export function hasDueTask(lead: LeadDetailsModel) {
  return lead.today_uncompleted_tasks_count > 0
}


export function getLeadStyles(lead: LeadDetailsModel): ServiceRequestStyleModel[]{
  return lead?.result?.styles || []
}
export interface ActivityDayGroup {
  key: string;
  label: string;
  items: LeadActivityModel[];
}

/** Groups consecutive activities by calendar day for the sticky date separators. */
export const groupActivitiesByDay = (
  activities: LeadActivityModel[],
  intl: {
    formatMessage: (descriptor: {
      id: string;
      defaultMessage: string;
    }) => string;
  },
): ActivityDayGroup[] => {
  const today = dayjs().format('YYYY-MM-DD');
  const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');

  return activities.reduce<ActivityDayGroup[]>((groups, activity) => {
    const date = dayjs(activity.created);
    const key = date.isValid() ? date.format('YYYY-MM-DD') : 'unknown';

    let group = groups[groups.length - 1];
    if (!group || group.key !== key) {
      let label = '';
      if (date.isValid()) {
        if (key === today) {
          label = intl.formatMessage({
            id: 'common.today',
            defaultMessage: 'Today',
          });
        } else if (key === yesterday) {
          label = intl.formatMessage({
            id: 'pages.common.yesterday',
            defaultMessage: 'Yesterday',
          });
        } else if (date.year() === dayjs().year()) {
          label = date.format('dddd, DD MMMM');
        } else {
          label = date.format('dddd, DD MMMM YYYY');
        }
      }
      group = { key, label, items: [] };
      groups.push(group);
    }
    group.items.push(activity);
    return groups;
  }, []);
};

export const getCallDuration = (text,intl) => {
  const duration = moment.duration(text, 'seconds');
          const hours = Math.floor(duration.asHours());
          const minutes = duration.minutes();
          const seconds = duration.seconds();

          const formattedDuration = [
            hours ? `${hours}h` : '',
            minutes ? `${minutes}m` : '',
            seconds ? `${seconds}s` : ''
          ].filter(Boolean).join(' ');

          return (
            formattedDuration ||
            intl.formatMessage({ id: 'pages.calls.noAnswer', defaultMessage: 'No answer' })
          );
}
